/**
 * Auth constants
 */

export const GUEST_GENERATION_LIMIT = parseInt(
  import.meta.env.VITE_GUEST_GENERATION_LIMIT || '15',
  10
);
